export function cleanStationName(name: string, maxLength = 30) {
  if (!name) return '';

  let cleaned = name.replace(/\s*-\s*\d+\s*m/g, '');
 
  if (cleaned.length > maxLength) {
    return `${cleaned.slice(0, maxLength)}…`;
  }

  return cleaned;
}